module.exports = __webpack_public_path__ + "static/media/Quarantine.e9f45c9d.mp3";